import "../../../styles/stores/receivedOrders/receivedOrders.css";
import { BsSearch, BsCalendarDay } from "react-icons/bs";
import EachReceiveOder from "../../../components/receivedOrder/EachReceiveOder";
import DetailOfReceivedOrder from "../../../components/receivedOrder/DetailOfReceivefOrder";
import { useState, useLayoutEffect, useEffect } from "react";
import { getRecievedOrderUrl } from "../../../api/endpoints";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../components/uxCollections/Loaders";
import { refreshUserToken } from "../../../tools/refreshToken";
import noItemSelectedImage from "../../../assetsStatic/noItemSelecteced.png";
import noReceivedOrder from "../../../assetsStatic/noReceivedOrderYet.png";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

const ReceivedOrder = ({ socket, refetch }) => {
  const [deliveryStatus, setDeliveryStatus] = useState("pending");
  const [receivedOrderList, setReceivedOrderList] = useState([]);
  const [receivedOrderListCopy, setReceivedOrderListCopy] = useState(null); // this would be used to filter the received order list
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(true); //
  const [setMobileParameters, setSetMobileParameters] = useState({
    timer: null,
    deliveryStatus: null,
    reloadDeliveryGauge: null,
  });
  const [filter, setFilter] = useState("All");

  const { store } = useSelector((state) => state.store);
  const userCurrency = useSelector((state) => state.webStoreUser.user.userCountryCurrencySymbol);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    fetchRecievedOrders();
  }, []);
  useLayoutEffect(() => {
    if (filter === "All") {
      setReceivedOrderList(receivedOrderListCopy);
    } else if (filter === "Pending") {
      setReceivedOrderList(receivedOrderListCopy.filter((order) => order.orderDetails.orderStatus === "pending"));
    } else if (filter === "Dispute") {
      setReceivedOrderList(receivedOrderListCopy.filter((order) => order.orderDetails.orderStatus === "dispute"));
    } else if (filter === "Query") {
      setReceivedOrderList(receivedOrderListCopy.filter((order) => order.orderDetails.orderStatus === "query"));
    } else if (filter === "Delivered") {
      setReceivedOrderList(receivedOrderListCopy.filter((order) => order.orderDetails.orderStatus === "delivered"));
    }
  }, [filter]);

  useEffect(() => {
    console.log("refetching", refetch);
    fetchRecievedOrders();
  }, [refetch]);

  const fetchRecievedOrders = async () => {
    try {
      const response = await fetch(getRecievedOrderUrl + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setReceivedOrderList(data);
        setReceivedOrderListCopy(data);
        setIsLoading(false);
      } else if (response.status === 400) {
        refreshUserToken(getRecievedOrderUrl + store._id, fetchRecievedOrders, navigate);
      } else {
        uiAlert("An error occured while fetching received orders, please try again later.", "error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const showIntervalTab = () => {
    let tab = document.querySelector(".chooseInterval");
    tab.classList.toggle("showInterval");
  };
  const updateFilter = (filter) => {
    setFilter(filter);
    showIntervalTab();
    setSelectedOrder(null);
  };

  return (
    <>
      {isLoading ? (
        <div style={{ position: "relative", height: "500px" }}>
          <Spinner position={"absolute"} transparent={false} backgroundColor={"#F9F9F9"} />
        </div>
      ) : receivedOrderList.length > 0 ? (
        <div style={{ overflowX: "hidden", position: "relative", height: "76vh" }}>
          <div className='searchRecievedOrdersDiv'>
            <h5>Received order</h5>
            <input className='SearchTransact1' placeholder='Enter order ID' />
            <span>
              <BsSearch />
            </span>
            <div className='TimelineTransactions'>
              <span onClick={showIntervalTab}> {filter} </span>
              <div style={{ bottom: "-210px" }} id='ReceiveOrderInterval' className='chooseInterval'>
                {filter !== "All" && <p onClick={() => updateFilter("All")}>All</p>}
                {filter !== "Pending" && <p onClick={() => updateFilter("Pending")}>Pending</p>}
                {filter !== "Dispute" && <p onClick={() => updateFilter("Dispute")}>Dispute</p>}
                {filter !== "Query" && <p onClick={() => updateFilter("Query")}>Query</p>}
                {filter !== "Delivered" && <p onClick={() => updateFilter("Delivered")}>Delivered</p>}
              </div>
            </div>
          </div>
          <div className='ReceivedOrderDivMain'>
            <div className='ReceivedOrders'>
              {receivedOrderList.length > 0 &&
                receivedOrderList
                  .slice(0)
                  .reverse()
                  .map((order) => (
                    <EachReceiveOder
                      key={order._id}
                      order={order}
                      delivery={deliveryStatus}
                      updateDelStat={setDeliveryStatus}
                      selectedOrder={selectedOrder}
                      setSelectedOrder={setSelectedOrder}
                      userCurrency={userCurrency}
                    />
                  ))}
            </div>
            <div className='ReceivedOrderDetailsDiv'>
              {/* instead of the delivery status the component would be feed with the selected received order data */}
              {selectedOrder ? (
                <DetailOfReceivedOrder
                  fetchRecievedOrders={fetchRecievedOrders}
                  selectedOrder={selectedOrder}
                  setSelectedOrder={setSelectedOrder}
                  socket={socket}
                  userCurrency={userCurrency}
                />
              ) : (
                <div className='noOrderSelectedYet'>
                  <img src={"https://res.cloudinary.com/ebuka1122/image/upload/v1710424163/static%20images%20storelens/noItemSelecteced_whgnaq.png"} />
                  <div>
                    <h3 style={{ textAlign: "center", marginBottom: "6px" }}>No order selected yet</h3>
                    <p>Click on an order to view details</p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className='mobileTransacGuarge2424'></div>
          {isLoading && <Spinner position={"absolute"} transparent={false} backgroundColor={"#F9F9F9"} />}
        </div>
      ) : (
        <div className='noOrders'>
          <div style={{ position: "absolute", top: "20px", right: "20px" }}>
            <div style={{}} className='TimelineTransactions'>
              <span onClick={showIntervalTab}> {filter} </span>
              <div style={{ bottom: "-210px" }} id='ReceiveOrderInterval' className='chooseInterval'>
                {filter !== "All" && <p onClick={() => updateFilter("All")}>All</p>}
                {filter !== "Pending" && <p onClick={() => updateFilter("Pending")}>Pending</p>}
                {filter !== "Dispute" && <p onClick={() => updateFilter("Dispute")}>Dispute</p>}
                {filter !== "Query" && <p onClick={() => updateFilter("Query")}>Query</p>}
                {filter !== "Delivered" && <p onClick={() => updateFilter("Delivered")}>Delivered</p>}
              </div>
            </div>
          </div>
          <img src={noReceivedOrder} />
          {receivedOrderListCopy ? (
            <h3>There is no {filter.toLowerCase()} order found</h3>
          ) : (
            <h3>
              Received Orders would appear <br></br> here
            </h3>
          )}
        </div>
      )}
    </>
  );
};

export default ReceivedOrder;
